"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.message = message;
exports.decode = decode;
exports.assertDecode = assertDecode;
exports.isDecode = isDecode;
exports.validateDecode = validateDecode;
exports.encode = encode;
exports.assertEncode = assertEncode;
exports.isEncode = isEncode;
exports.validateEncode = validateEncode;
exports.createDecode = createDecode;
exports.createIsDecode = createIsDecode;
exports.createAssertDecode = createAssertDecode;
exports.createValidateDecode = createValidateDecode;
exports.createEncode = createEncode;
exports.createIsEncode = createIsEncode;
exports.createAssertEncode = createAssertEncode;
exports.createValidateEncode = createValidateEncode;
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
/** @internal */
function message() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.message");
}
/** @internal */
function decode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.decode");
}
/** @internal */
function assertDecode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.assertDecode");
}
/** @internal */
function isDecode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.isDecode");
}
/** @internal */
function validateDecode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.validateDecode");
}
/** @internal */
function encode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.encode");
}
/** @internal */
function assertEncode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.assertEncode");
}
/** @internal */
function isEncode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.isEncode");
}
/** @internal */
function validateEncode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.validateEncode");
}
/** @internal */
function createDecode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createDecode");
}
/** @internal */
function createIsDecode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createIsDecode");
}
/** @internal */
function createAssertDecode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createAssertDecode");
}
/** @internal */
function createValidateDecode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createValidateDecode");
}
/** @internal */
function createEncode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createEncode");
}
/** @internal */
function createIsEncode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createIsEncode");
}
/** @internal */
function createAssertEncode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createAssertEncode");
}
/** @internal */
function createValidateEncode() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("protobuf.createValidateEncode");
}
//# sourceMappingURL=protobuf.js.map